import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Input } from "elza-react";
import CloseImg from "../svg/ICON_close_dark.svg";
import "../css/ProductSelect.css";

/**
 * ProductSelect component
 */
class ProductSelect extends React.Component {
  static displayName = "ProductSelect";
  static propTypes = {
    className: PropTypes.string,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "FormOffer";
    this.state = {
      selection: [],
    };

    _.bindAll(
      this,
      "field",
      "updateField",
      "removeField",
      "addField",
      "isSelected",
      "getCategory"
    );
  }

  formatArray(category) {
    const products = category.products().map((p) => (
      <option
        className="product"
        key={p.ID}
        value={p.ID}
        data-category={category.ID}
      >
        {p.ArtID} {p.Label}
      </option>
    ));
    if (products.size < 1) return [];
    return (
      <optgroup label={category.Title} key={category.ID}>
        {products}
      </optgroup>
    );
  }

  isSelected(productID) {
    return this.state.selection.some((p) => p === productID);
  }

  getCategory(productID) {
    console.log(
      "find the category for this product",
      productID,
      this.props.products.toJS()
    );
    const category = this.props.products.find((cat) =>
      cat.products().some((p) => p.ID === _.toInteger(productID))
    );
    if (category) return category;
    return null;
  }

  field(productID, number, onChange) {
    let unit = "";
    let key = number;
    if (this.isSelected(productID)) {
      const cat = this.getCategory(productID);
      if (cat) {
        unit = cat.unit().Title;
      }
      key += cat.ID;
    }
    return (
      <div key={key} className={`${this.className}__field select`}>
        <div className={`${this.className}__label`}>Produit {number}</div>
        <select
          className={`${this.className}__select`}
          name="ProductSelected"
          onChange={onChange}
          defaultValue={productID ? productID : null}
        >
          <option
            className="placeholder"
            value={null}
            disabled={!_.isNil(productID)}
          >
            Choisir
          </option>
          {this.props.products.map(this.formatArray)}
        </select>
        <div
          className={`${this.className}__qte`}
          style={unit ? {} : { opacity: 0 }}
        >
          <div>Quantité</div>
          <Input
            name={`offer.Products[${_.toInteger(productID)}]`}
            value={0}
            type="text"
          />
          <div dangerouslySetInnerHTML={{ __html: unit }} />
        </div>
        <div
          className={`${this.className}__remove`}
          onClick={() => this.removeField(number)}
          style={unit ? {} : { opacity: 0 }}
        >
          supprimer
          <img src={CloseImg} alt="x" className="icon" />
        </div>
      </div>
    );
  }

  addField(ev) {
    const productID = ev.target.value;
    this.setState({ selection: [...this.state.selection, productID] });
  }

  updateField(ev, index) {
    const productID = ev.target.value;
    const selection = this.state.selection.map((sel, idx) =>
      index === idx ? productID : sel
    );
    this.setState({ selection });
  }

  removeField(number) {
    const selection = this.state.selection.filter((p, i) => i !== number - 1);
    this.setState({ selection });
  }

  /**
   * @override
   */
  render() {
    return (
      <div className={`${this.className}__selects`}>
        {this.state.selection.map((productID, index) =>
          this.field(productID, index + 1, (ev) => this.updateField(ev, index))
        )}
        {this.field(null, this.state.selection.length + 1, this.addField)}
      </div>
    );
  }
}

export default ProductSelect;



// WEBPACK FOOTER //
// ./src/components/ProductSelect.js